import axios from "./axios-auth";

const login = (user) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/auth/login",
      data: user,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp);
        if (resp.status === 200) {
          resolve(resp);
        } else if (resp.status === 403) {
          throw "Incorrect user name and/or password/otp";
        } else {
          throw "Unknow error";
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

  const loginViaOTP = (user) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/auth/login-via-otp",
      data: user,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp);
        if (resp.status === 200) {
          resolve(resp);
        } else if (resp.status === 403) {
          throw "Incorrect Username/OTP";
        } else if (resp.status === 400) {
          throw "Incorrect OTP, Please enter correct OTP or request a new one ";
        } else {
          throw "Unknown error";
        }
      })
      .catch((err) => {
        reject(err);
      });
  });


const autologin = ({ token: token, is_divvy_admin_flow: is_divvy_admin_flow }) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/auth/autologin",
      data: {
        token: token,
        is_divvy_admin_flow: is_divvy_admin_flow,
      },
      method: "POST",
    })
      .then((resp) => {
        const jwtToken = resp.data.jwtToken;
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });

const requestPasswordEmail = (email) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/auth/password/email",
      data: {
        email: email,
      },
      method: "POST",
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getLegacyAccessToken = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/legacy/accessToken",
      method: "GET",
    })
      .then((resp) => {
        const accessToken = {
          token: resp.data.token,
          loginUrl: resp.data.loginUrl,
        };
        resolve(accessToken);
      })
      .catch((err) => {
        reject(err);
      });
  });

const adminLogin = (user) =>
  new Promise((resolve, reject) => {
    axios({
      url: "auth/divvylogin",
      data: user,
      method: "POST",
    })
      .then((resp) => {
        if (resp.status === 200) {
          const jwtToken = resp.data.jwtToken;
          console.log(resp);
          resolve(jwtToken);
        } else if (resp.status != 200) {
          throw "Invalid username and password.";
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

export {
  login,
  loginViaOTP,
  autologin,
  requestPasswordEmail,
  getLegacyAccessToken,
  adminLogin,
};
